(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brewing-guides"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-brewg]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-brewg-tab]');
      var panels = root.querySelectorAll('[data-brewg-panel]');
      if (!tabs.length) return;

      function close(index) {
        tabs[index].setAttribute('aria-selected', 'false');
        panels[index].hidden = true;
      }

      function open(index) {
        tabs.forEach(function (tab, i) {
          if (i !== index) close(i);
        });
        tabs[index].setAttribute('aria-selected', 'true');
        panels[index].hidden = false;
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          var isOpen = tab.getAttribute('aria-selected') === 'true';
          if (isOpen) {
            close(index);
          } else {
            open(index);
          }
        });

        tab.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (next === null) return;
          event.preventDefault();
          tabs[next].focus();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-chero]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var formWrap = section.querySelector('[data-chero-form]');

      /* reveal the form dramatically on scroll */
      if (formWrap) {
        if (!('IntersectionObserver' in window)) {
          formWrap.classList.add('is-open');
        } else {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                formWrap.classList.add('is-open');
                io.unobserve(entry.target);
              }
            });
          }, { threshold: 0.18, rootMargin: '0px 0px -10% 0px' });
          io.observe(formWrap);
        }
      }

      /* smooth-scroll to the form */
      section.querySelectorAll('[data-chero-scroll]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (formWrap) formWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-roast-builder-v2"]) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-croast]');
    if (!sections.length) return;
    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (s) { s.classList.add('is-inview'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    sections.forEach(function (s) { io.observe(s); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-roast-builder"]) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-croast]');
    if (!sections.length) return;
    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (s) { s.classList.add('is-inview'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    sections.forEach(function (s) { io.observe(s); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filter-coffee-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-fch]');
    if (!sections.length) return;

    function reveal(el) { el.classList.add('is-visible'); }

    sections.forEach(function (section) {
      /* scroll reveal */
      var items = section.querySelectorAll('.rv');
      if (!('IntersectionObserver' in window)) {
        items.forEach(reveal);
      } else if (items.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              reveal(entry.target);
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
        items.forEach(function (el) { io.observe(el); });
      }

      /* carousel dots */
      var track = section.querySelector('[data-fch-track]');
      var dots = section.querySelectorAll('[data-fch-dot]');
      if (track && dots.length) {
        var cards = track.querySelectorAll('[data-fch-card]');
        var setActiveDot = function (i) {
          dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
        };
        var nearestIndex = function () {
          var center = track.scrollLeft + track.clientWidth / 2;
          var best = 0, bestDist = Infinity;
          cards.forEach(function (c, ci) {
            var cc = c.offsetLeft + c.clientWidth / 2;
            var dist = Math.abs(cc - center);
            if (dist < bestDist) { bestDist = dist; best = ci; }
          });
          return best;
        };
        var raf = null;
        track.addEventListener('scroll', function () {
          if (raf) return;
          raf = requestAnimationFrame(function () { raf = null; setActiveDot(nearestIndex()); });
        }, { passive: true });
        dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () {
            var card = cards[i];
            if (!card) return;
            var left = card.offsetLeft - (track.clientWidth - card.clientWidth) / 2;
            track.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
          });
        });
      }

      /* add-to-cart modal */
      var modal = section.querySelector('[data-fch-modal]');
      if (!modal) return;
      var mImg = modal.querySelector('[data-fch-modal-img]');
      var mTitle = modal.querySelector('[data-fch-modal-title]');
      var mLabel = modal.querySelector('[data-fch-modal-label]');
      var mVariants = modal.querySelector('[data-fch-modal-variants]');
      var mAdd = modal.querySelector('[data-fch-modal-add]');
      var mMsg = modal.querySelector('[data-fch-modal-msg]');
      var selectedId = null;
      var lastTrigger = null;

      function openModal() {
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function () { modal.classList.add('is-open'); });
        document.addEventListener('keydown', onKey);
      }
      function closeModal() {
        modal.classList.remove('is-open');
        document.removeEventListener('keydown', onKey);
        setTimeout(function () {
          modal.hidden = true;
          modal.setAttribute('aria-hidden', 'true');
        }, 320);
        if (lastTrigger) { try { lastTrigger.focus(); } catch (e) {} }
      }
      function onKey(e) { if (e.key === 'Escape') closeModal(); }

      function selectVariant(id, btn) {
        selectedId = id;
        mVariants.querySelectorAll('.fch-modal__variant').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
      }

      function buildModal(data) {
        mMsg.textContent = '';
        mMsg.innerHTML = '';
        mAdd.disabled = false;
        mAdd.textContent = 'Add to cart';
        mTitle.textContent = data.title || '';
        if (mImg) {
          if (data.image) { mImg.src = data.image; mImg.style.display = ''; }
          else { mImg.removeAttribute('src'); mImg.style.display = 'none'; }
        }
        mVariants.innerHTML = '';
        selectedId = null;
        var variants = data.variants || [];
        var multi = variants.length > 1;
        mLabel.style.display = multi ? '' : 'none';
        var firstAvailable = null;
        variants.forEach(function (v) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'fch-modal__variant';
          btn.setAttribute('role', 'radio');
          btn.innerHTML = v.title + (v.price ? ' <small>' + v.price + '</small>' : '');
          if (!v.available) {
            btn.disabled = true;
            btn.setAttribute('aria-disabled', 'true');
          } else {
            btn.addEventListener('click', function () { selectVariant(v.id, btn); });
            if (firstAvailable === null) firstAvailable = { id: v.id, btn: btn };
          }
          btn.setAttribute('aria-pressed', 'false');
          mVariants.appendChild(btn);
        });
        if (firstAvailable) selectVariant(firstAvailable.id, firstAvailable.btn);
      }

      function flyToCart(from) {
        var target = document.querySelector('.header-actions__cart-icon');
        if (from && from.classList) {
          var label = from.textContent;
          from.classList.add('is-added');
          from.textContent = 'Added \u2713';
          setTimeout(function () { from.classList.remove('is-added'); from.textContent = label; }, 1800);
        }
        if (!target || !from || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var a = from.getBoundingClientRect();
        var b = target.getBoundingClientRect();
        var bean = document.createElement('span');
        bean.className = 'cpdp-bean';
        bean.style.left = (a.left + a.width / 2 - 7) + 'px';
        bean.style.top = (a.top + a.height / 2 - 9) + 'px';
        document.body.appendChild(bean);
        var dx = b.left + b.width / 2 - (a.left + a.width / 2);
        var dy = b.top + b.height / 2 - (a.top + a.height / 2);
        bean.animate([
          { transform: 'translate(0, 0) rotate(0deg) scale(1)', opacity: 1 },
          { transform: 'translate(' + dx * 0.55 + 'px, ' + (dy * 0.55 - 80) + 'px) rotate(200deg) scale(1.1)', opacity: 1, offset: 0.55 },
          { transform: 'translate(' + dx + 'px, ' + dy + 'px) rotate(360deg) scale(0.5)', opacity: 0.2 }
        ], { duration: 750, easing: 'cubic-bezier(0.5, 0, 0.6, 1)' }).finished.then(function () {
          bean.remove();
          target.animate([
            { transform: 'scale(1) rotate(0)' },
            { transform: 'scale(1.25) rotate(-8deg)' },
            { transform: 'scale(0.95) rotate(4deg)' },
            { transform: 'scale(1) rotate(0)' }
          ], { duration: 500, easing: 'ease-out' });
        });
      }

      section.querySelectorAll('[data-fch-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var card = btn.closest('[data-fch-card]');
          var script = card && card.querySelector('[data-fch-product]');
          if (!script) return;
          var data;
          try { data = JSON.parse(script.textContent); } catch (e) { return; }
          lastTrigger = btn;
          buildModal(data);
          openModal();
        });
      });

      modal.querySelectorAll('[data-fch-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });

      mAdd.addEventListener('click', function () {
        if (!selectedId) { mMsg.textContent = 'Please choose a size.'; return; }
        mAdd.disabled = true;
        mAdd.textContent = 'Adding…';
        var sectionIds = [];
        document.querySelectorAll('cart-items-component').forEach(function (el) {
          if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
        });
        var payload = { items: [{ id: selectedId, quantity: 1 }] };
        if (sectionIds.length) payload.sections = sectionIds.join(',');
        fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
          .then(function (res) {
            if (!res.ok) {
              mMsg.textContent = (res.body && res.body.description) || 'Sorry, that could not be added.';
              mAdd.disabled = false;
              mAdd.textContent = 'Add to cart';
              return;
            }
            mAdd.textContent = 'Added ✓';
            mMsg.innerHTML = 'Added to your cart. <a href="/cart">View cart</a>';
            var addedId = String(selectedId);
            var sections = res.body && res.body.sections;
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .catch(function () { return undefined; })
              .then(function (cart) {
                return import('@theme/events').then(function (ev) {
                  closeModal();
                  flyToCart(lastTrigger || mAdd);
                  mAdd.dispatchEvent(new ev.CartAddEvent(cart, addedId, {
                    source: 'product-form-component',
                    itemCount: 1,
                    sections: sections
                  }));
                });
              })
              .catch(function () {
                window.location.href = '/cart';
              });
          })
          .catch(function () {
            mMsg.textContent = 'Something went wrong. Please try again.';
            mAdd.disabled = false;
            mAdd.textContent = 'Add to cart';
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var els = document.querySelectorAll('[data-iglink]');
    if (!els.length) return;
    els.forEach(function (el) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { el.classList.add('is-inview'); io.unobserve(el); } });
        }, { threshold: 0.2 });
        io.observe(el);
      } else { el.classList.add('is-inview'); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["join-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-joinx]');
    if (!sections.length) return;
    sections.forEach(function (section) {
      if (!('IntersectionObserver' in window)) { section.classList.add('is-inview'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { section.classList.add('is-inview'); io.unobserve(section); }
        });
      }, { threshold: 0.12 });
      io.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function () {
    var pages = document.querySelectorAll('.auth-page');
    if (!pages.length) return;
    if (!('IntersectionObserver' in window)) {
      pages.forEach(function (p) { p.classList.add('is-inview'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    pages.forEach(function (p) { io.observe(p); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  (function () {
    var pages = document.querySelectorAll('.auth-page');
    if (!pages.length) return;
    if (!('IntersectionObserver' in window)) {
      pages.forEach(function (p) { p.classList.add('is-inview'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    pages.forEach(function (p) { io.observe(p); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ost]').forEach(function (section) {
      if ('IntersectionObserver' in window) {
        section.classList.add('is-armed');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { section.classList.add('is-inview'); io.unobserve(section); }
          });
        }, { threshold: 0.15 });
        io.observe(section);
      } else {
        section.classList.add('is-inview');
      }

      /* with the script running, the two languages share the page and the
         switch chooses between them */
      var buttons = section.querySelectorAll('[data-ost-lang]');
      var panels = section.querySelectorAll('[data-ost-content]');
      if (!buttons.length || panels.length < 2) return;

      function show(lang) {
        section.setAttribute('data-lang', lang);
        buttons.forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-ost-lang') === lang ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-ost-content') === lang;
          panel.classList.toggle('is-active', active);
          panel.inert = !active;
        });
      }

      section.classList.add('has-switch');
      buttons.forEach(function (button) {
        button.addEventListener('click', function () { show(button.getAttribute('data-ost-lang')); });
      });
      show('primary');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-vision"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ovs]').forEach(function (section) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { section.classList.add('is-inview'); io.unobserve(section); }
          });
        }, { threshold: 0.2 });
        io.observe(section);
      } else {
        section.classList.add('is-inview');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personalise-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-pcta]');
    if (!sections.length) return;
    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (s) { s.classList.add('is-inview'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    sections.forEach(function (s) { io.observe(s); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policies"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-pol]');
    if (!sections.length) return;

    function openItem(item) {
      var list = item.closest('.pol__list') || item.parentNode;
      list.querySelectorAll('.pol__item').forEach(function (other) {
        other.classList.remove('is-open');
        var b = other.querySelector('[data-pol-q]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      item.classList.add('is-open');
      var btn = item.querySelector('[data-pol-q]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }

    sections.forEach(function (section) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { section.classList.add('is-inview'); io.unobserve(section); } });
        }, { threshold: 0.12 });
        io.observe(section);
      } else {
        section.classList.add('is-inview');
      }

      section.querySelectorAll('.pol__item').forEach(function (item) {
        var btn = item.querySelector('[data-pol-q]');
        if (!btn) return;
        btn.addEventListener('click', function () {
          if (item.classList.contains('is-open')) {
            item.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
          } else {
            openItem(item);
          }
        });
      });
    });

    /* open a policy when its anchor is linked (e.g. from the footer) */
    function openFromHash() {
      var h = location.hash;
      if (!h || h.indexOf('#policy-') !== 0) return;
      var target = document.getElementById(h.slice(1));
      if (!target || !target.classList.contains('pol__item')) return;
      openItem(target);
      setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 60);
    }
    window.addEventListener('hashchange', openFromHash);
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href*="#policy-"]') : null;
      if (a) setTimeout(openFromHash, 0);
    });
    if (location.hash) setTimeout(openFromHash, 350);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roasted-on-order"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-roo]');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (s) { s.classList.add('is-inview'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    sections.forEach(function (s) { io.observe(s); });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-categories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-shopx]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      // Belt-and-braces alongside the autoplay/muted/playsinline attributes
      // already on the tag (see the liquid above): a handful of mobile
      // engines silently decline attribute-only autoplay depending on
      // battery-saver / data-saver state, and only honour an explicit,
      // gesture-free play() call. Muted video is exempt from every major
      // engine's autoplay-blocking policy, so this call is expected to
      // succeed; the catch just swallows the rare hard block rather than
      // surfacing a console error for something the page doesn't need to
      // recover from.
      var bannerVideo = section.querySelector('.shopx__video');
      if (bannerVideo) {
        var tryPlayBanner = function () {
          bannerVideo.play().catch(function () {});
        };
        tryPlayBanner();
        bannerVideo.addEventListener('loadeddata', tryPlayBanner, { once: true });
        bannerVideo.addEventListener('canplay', tryPlayBanner, { once: true });
      }

      var tabs = section.querySelectorAll('[data-shopx-tab]');
      var panes = section.querySelectorAll('[data-shopx-pane]');

      function setActive(idx) {
        if (section.getAttribute('data-active') === String(idx)) return;
        section.setAttribute('data-active', String(idx));
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', t.getAttribute('data-shopx-tab') === String(idx) ? 'true' : 'false');
        });
        panes.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-shopx-pane') === String(idx));
        });
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var idx = parseInt(t.getAttribute('data-shopx-tab'), 10);
          if (!isNaN(idx)) setActive(idx);
        });
      });

      function activate() { section.classList.add('is-inview'); }
      if (!('IntersectionObserver' in window)) { activate(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { activate(); io.unobserve(section); }
        });
      }, { threshold: 0.05 });
      io.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var footers = document.querySelectorAll('[data-sf]');
    if (!footers.length) return;

    footers.forEach(function (footer) {
      var modal = footer.querySelector('[data-sf-modal]');
      if (!modal) return;
      var mTitle = modal.querySelector('[data-sf-modal-title]');
      var mBody = modal.querySelector('[data-sf-modal-body]');
      var lastTrigger = null;

      function onKey(e) { if (e.key === 'Escape') closeModal(); }
      function openModal() {
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function () { modal.classList.add('is-open'); });
        document.addEventListener('keydown', onKey);
      }
      function closeModal() {
        modal.classList.remove('is-open');
        document.removeEventListener('keydown', onKey);
        setTimeout(function () { modal.hidden = true; modal.setAttribute('aria-hidden', 'true'); }, 320);
        if (lastTrigger) { try { lastTrigger.focus(); } catch (e) {} }
      }

      footer.querySelectorAll('[data-sf-policy]').forEach(function (link) {
        link.addEventListener('click', function () {
          var idx = link.getAttribute('data-sf-policy');
          var tpl = footer.querySelector('[data-sf-content="' + idx + '"]');
          mTitle.textContent = link.textContent;
          mBody.innerHTML = tpl ? tpl.innerHTML : '';
          modal.scrollTop = 0;
          lastTrigger = link;
          openModal();
        });
      });
      modal.querySelectorAll('[data-sf-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var carousels = document.querySelectorAll('[data-tst-carousel]');
    if (!carousels.length) return;

    carousels.forEach(function (root) {
      var track = root.querySelector('[data-tst-track]');
      var prev = root.querySelector('[data-tst-prev]');
      var next = root.querySelector('[data-tst-next]');
      var dotsBox = root.querySelector('[data-tst-dots]');
      if (!track) return;

      var cards = Array.prototype.slice.call(track.children);
      if (!cards.length) return;

      function getVisible() {
        var styles = getComputedStyle(root);
        var v = parseFloat(styles.getPropertyValue('--tst-visible')) || 1;
        return Math.max(1, Math.floor(v));
      }

      function pages() {
        var visible = getVisible();
        return Math.max(1, Math.ceil(cards.length / visible));
      }

      function currentPage() {
        var visible = getVisible();
        var pageWidth = track.clientWidth;
        if (!pageWidth) return 0;
        var idx = Math.round(track.scrollLeft / pageWidth);
        return Math.min(pages() - 1, Math.max(0, idx));
      }

      function scrollToPage(p) {
        var pageWidth = track.clientWidth;
        track.scrollTo({ left: pageWidth * p, behavior: 'smooth' });
      }

      function updateArrows() {
        var multiPage = pages() > 1;
        if (prev) {
          prev.hidden = !multiPage;
          prev.disabled = track.scrollLeft <= 2;
        }
        if (next) {
          next.hidden = !multiPage;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        }
      }

      function buildDots() {
        if (!dotsBox) return;
        dotsBox.innerHTML = '';
        var total = pages();
        if (total <= 1) {
          dotsBox.hidden = true;
          return;
        }
        dotsBox.hidden = false;
        for (var i = 0; i < total; i++) {
          (function (idx) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'tst__dot';
            b.setAttribute('role', 'tab');
            b.setAttribute('aria-label', 'Page ' + (idx + 1));
            b.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
            b.addEventListener('click', function () { scrollToPage(idx); });
            dotsBox.appendChild(b);
          })(i);
        }
      }

      function updateDots() {
        if (!dotsBox || dotsBox.hidden) return;
        var page = currentPage();
        var dots = dotsBox.querySelectorAll('.tst__dot');
        dots.forEach(function (d, i) {
          d.setAttribute('aria-selected', i === page ? 'true' : 'false');
        });
      }

      /* "Show more" appears only on clamped quotes and opens the whole row together */
      var moreButtons = Array.prototype.slice.call(track.querySelectorAll('[data-tst-more]'));
      moreButtons.forEach(function (b) { b.setAttribute('data-label-more', b.textContent.trim()); });

      function updateClamps() {
        if (track.classList.contains('is-expanded')) return;
        moreButtons.forEach(function (b) {
          var card = b.closest('.tst__card');
          var text = card && card.querySelector('.tst__quote-text');
          b.hidden = !text || text.scrollHeight <= text.clientHeight + 1;
        });
      }

      moreButtons.forEach(function (b) {
        b.addEventListener('click', function () {
          var expanded = !track.classList.contains('is-expanded');
          track.classList.toggle('is-expanded', expanded);
          moreButtons.forEach(function (other) {
            other.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            other.textContent = other.getAttribute(expanded ? 'data-label-less' : 'data-label-more');
          });
          if (!expanded) updateClamps();
        });
      });

      if (prev) prev.addEventListener('click', function () {
        scrollToPage(Math.max(0, currentPage() - 1));
      });
      if (next) next.addEventListener('click', function () {
        scrollToPage(Math.min(pages() - 1, currentPage() + 1));
      });

      var rafId = null;
      track.addEventListener('scroll', function () {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(function () {
          updateArrows();
          updateDots();
        });
      });

      buildDots();
      updateArrows();
      updateClamps();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(updateClamps);

      var ro = ('ResizeObserver' in window) ? new ResizeObserver(function () {
        updateClamps();
        buildDots();
        updateArrows();
        updateDots();
      }) : null;
      if (ro) ro.observe(root);
      else window.addEventListener('resize', function () {
        updateClamps();
        buildDots();
        updateArrows();
        updateDots();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
